import App from '../app';
import "../../css/contact.css";

const ContactInjectCSS = {
  init: function (){}
};

App.init({ ContactInjectCSS });
